import type { ProjectConfig } from '../../types/config';
import { MenuTypeEnum } from '../enums/menuEnum';
import { getConfigByMenuType } from '../utils/getConfigByMenuType';
// 修改此属性，实现默认的四个系统主题快速切换
const menuType = MenuTypeEnum.SIDEBAR;

// update-begin--author:liaozhiyang---date:20251201---for【QQYUN-14176】修改一个配置就能切换默认四个主题，不需要额外修改颜色等
const { themeColor, headerBgColor, sideBgColor, split, mode } = getConfigByMenuType(menuType);
// update-end--author:liaozhiyang---date:20251201---for【QQYUN-14176】修改一个配置就能切换默认四个主题，不需要额外修改颜色等
// ! 改动后需要清空浏览器缓存
const setting: ProjectConfig = {
  showSettingButton: false,
  showDarkModeToggle: true,
  settingButtonPosition: 'auto',
  permissionMode: 'BACK',
  permissionCacheType: 1,
  sessionTimeoutProcessing: 0,
  themeColor: '#1890ff',
  themeMode: 'light',
  grayMode: false,
  colorWeak: false,
  fullContent: false,
  contentMode: 'full',
  showLogo: true,
  showFooter: false,
  aiIconShow: false,
  headerSetting: {
    bgColor: '#394664',
    fixed: true,
    show: true,
    theme: 'dark',
    useLockPage: false,
    showFullScreen: false,
    showDoc: false,
    showNotice: false,
    showSearch: false,
  },
  menuSetting: {
    bgColor: '#273352',
    fixed: true,
    collapsed: false,
    collapsedShowTitle: false,
    canDrag: false,
    show: true,
    hidden: false,
    menuWidth: 210,
    mode: 'horizontal',
    type: 'top-menu',
    theme: 'dark',
    isThemeBright: false,
    split: false,
    topMenuAlign: 'center',
    trigger: 'HEADER',
    accordion: true,
    closeMixSidebarOnChange: false,
    mixSideTrigger: 'click',
    mixSideFixed: false,
  },
  multiTabsSetting: {
    cache: false,
    show: true,
    canDrag: true,
    showQuick: true,
    showRedo: true,
    showFold: true,
    theme: 'simple',
  },
  transitionSetting: {
    enable: true,
    basicTransition: 'fade-slide',
    openPageLoading: true,
    openNProgress: true,
  },
  openKeepAlive: true,
  lockTime: 0,
  showBreadCrumb: false,
  showBreadCrumbIcon: true,
  useErrorHandle: false,
  useOpenBackTop: true,
  canEmbedIFramePage: true,
  closeMessageOnSwitch: true,
  removeAllHttpPending: false,
};

export default setting;
